import React from 'react';
import {
  DefaultExceptionPlaceholder,
  UnauthorizedErrorPlaceholder,
} from '@/placeholders';
import { BaseErrorBoundary } from './base-error-boundary';
import { ERROR_TYPES } from './errors';

/**
 * Root Error boundary that wraps app.jsx. "Catch All" error boundary to catch any
 * uncaught errors that bubble to the root of the application
 *
 * @export
 * @class RootErrorBoundary
 * @extends {BaseErrorBoundary}
 */
export class RootErrorBoundary extends BaseErrorBoundary {
  render() {
    if (this.state.hasError) {
      switch (this.state.errorType) {
        case ERROR_TYPES.UnauthorizedException:
          return <UnauthorizedErrorPlaceholder />;
        default:
          return <DefaultExceptionPlaceholder />;
      }
    }
    return this.props.children;
  }
}
